const Home = () => {
  return null;
};

export default Home;
